import { ref } from 'vue'
import { useCommonStore } from 'stores/common'
import { useQuasar } from 'quasar'

export default function () {
  const store = useCommonStore()
  const $q = useQuasar()
  store.setMobileState(ref($q.platform.is.mobile).value)
}
